<irb-common-overlay #overlayComponent></irb-common-overlay>

<div class="option-chain-container">
  <form [formGroup]="formGroup" (submit)="handleOptionSubmit()">
    <div class="input-symbol">
      <div class="col">
        <label for="underlyingSymbol">Underlying symbol</label>
        <input
          data-symbol
          id="underlyingSymbol"
          type="text"
          #underlyingSymbolInput
          formControlName="underlyingSymbol"
          autocomplete="off"
          />
        </div>
        <div class="col">
          <label for="chainType">Chain type</label>
          <irb-dropdown-filter #IrbDropdownFilterOff
            id="chainTypeDropdown"
            [value]="formGroup.controls.chainType.value"
            (search)="setChainTypeOptions()"
            (selection)="selectOption($event)"
            [disabled]="chainTypeDisabled"
          ></irb-dropdown-filter>
        </div>
        <div class="col">
          <label for="strikePrice">Strike</label>
          <irb-number-text-box id="strikePrice"
            name="strikePrice"
            [(value)]="strikePrice" min="0" max="10000000000000000"
            places="2"
            invalidRangeMessage="The Value is out of range"
            invalidMessage="Invalid amount"
            placeholder="" width="155px" >
          </irb-number-text-box>
        </div>
        <div class="col button">
          <button data-view-chain type="submit" id="viewChainButton" class="btn-medium-secondary"
            [disabled]="!formGroup.get('underlyingSymbol').value || formGroup.invalid">
            View Chain
          </button>
        </div>
      </div>
    </form>

    <div class="input-slider">
      <div class="d-flex prob-worth">
        <div class="col1 bold d-flex">
          <div>Probability of Expiring Worthless (est)</div>
          <div class="infoIcon" calltoaction
            [calltoactionTemplate]="optionChainToolTipTemplateRef"
            [calltoactionPosition]="'right'">
          </div>
          <ng-template #optionChainToolTipTemplateRef>
            <div>The estimated Probability of Expiring Worthless is calculated as 1-Delta.</div>
          </ng-template>
        </div>
        <div class="col2">
          <irb-number-text-box name="probWorthStart"
            [(value)]="expiringWorthLessValues[0]" min="0" max="100"
            [isPercentage]="true"
            (valueChange)="handleSliderProbWorthInputChange()"
            invalidRangeMessage="Please enter only numbers between 0 and 100"
            invalidMessage="Please enter only whole numbers"
            placeholder="" width="60px"
            class="prob-worth-start">
          </irb-number-text-box>
          <span class="to">to</span>
          <irb-number-text-box name="probWorthEnd"
            [(value)]="expiringWorthLessValues[1]" min="0" max="100"
            [isPercentage]="true"
            (valueChange)="handleSliderProbWorthInputChange()"
            invalidRangeMessage="Please enter only numbers between 0 and 100"
            invalidMessage="Please enter only whole numbers"
            placeholder="" width="60px"
            class="prob-worth-end">
          </irb-number-text-box>
          <span> %</span>
        </div>
        <div class="col3">
          <p-slider name="expiringWorthLessValues" [(ngModel)]="expiringWorthLessValues"
            [range]="true" (onChange)="handleSliderChange()">
          </p-slider>
          <div class="slider-mark-container">
            @for (i of arr(probSliderNumber).fill(1); track i) {
              <div></div>
            }
          </div>
          <div class="slider-label-container">
            <div class="step-1">0</div>
            <div class="step-2">50</div>
            <div class="step-3">100</div>
          </div>
        </div>
      </div>
      <div class="d-flex dte">
        <div class="col1">
          <span class="bold">Days To Expiration&emsp;</span>
          <p-checkbox
            binary="true"
            [(ngModel)]="showAllExpirations"
            inputId="showAllExpirations"
            (onChange)="handleShowAllExpiration()"
            styleClass="show-all-expirations"
            labelStyleClass="show-all-expirations-label"
          ></p-checkbox>
          <label for="showAllExpirations" class="show-all-expirations-label">Show All Expirations</label>
        </div>
        <div class="col2">
          <irb-number-text-box name="dteStart"
            [(value)]="daysToExpiration[0]" min="0" [max]="daysToExpiration[1]"
            (valueChange)="handleSliderDTEInputChange()"
            [disabled]="showAllExpirations"
            invalidRangeMessage="Please enter only numbers between 0 and 365"
            invalidMessage="Please enter only whole numbers"
            placeholder="" width="60px">
          </irb-number-text-box>
          <span class="to">to</span>
          <irb-number-text-box name="dteEnd"
            [(value)]="daysToExpiration[1]" min="0" max="365"
            (valueChange)="handleSliderDTEInputChange()"
            [disabled]="showAllExpirations"
            invalidRangeMessage="Please enter only numbers between 0 and 365"
            invalidMessage="Please enter only whole numbers"
            placeholder="" width="60px">
          </irb-number-text-box>
          days
        </div>
        <div class="col3">
          <p-slider name="daysToExpiration" [(ngModel)]="daysToExpiration"
            [range]="true" [min]="0" [max]="365" [disabled]="showAllExpirations"
            (onChange)="handleSliderChange()">
          </p-slider>
          <div class="slider-mark-container">
            @for (i of arr(dteSliderNumber).fill(1); track i) {
              <div></div>
            }
          </div>
          <div class="slider-label-container">
            <div class="step-1">0</div>
            <div class="step-2">90</div>
            <div class="step-3">180</div>
            <div class="step-3">270</div>
            <div class="step-3">365</div>
          </div>
        </div>
      </div>
    </div>

    <div class="output">
      @if (isDataAvailable) {
        <div class="success-results">
          <div class="header">
            <div class="selected-chain-type">
              {{ selectedChainType }}
              <!-- {{ optionsChainTableData?.symbol }} -->
            </div>
            @if (currentTime) {
              <div class="current-time">
                As of: {{ currentTime | date: 'MM/dd/yyyy hh:mm:ss a' : '-0500' }} ET
              </div>
            }
            <div class="refresh">
              <a (click)="refresh()">
                <img src="../../assets/images/reset1.png" title="Refresh" width="14" height="14"/>
              </a>
            </div>
            <div>
              @if (!allExpandState) {
                <a (click)="openAll()"> Expand all chains</a>
              }
              @if (allExpandState) {
                <a (click)="closeAll()"> Collapse all chains</a>
              }
            </div>
            <div class="show-details">
              <a
                [ngClass]="!isDetailsLink ? 'disabled' : ''"
                (click)="handleShowDetails()"> Show {{ showDetails ? 'fewer' : 'more' }}  details
              </a>
            </div>
          </div>
          <div class="grid-scroll">
            @if (selectedChainType !== 'Puts') {
              <mat-accordion multi [togglePosition]="'before'">
                @for (callExpDateMap of optionsChainTableData?.callExpDateMap | keyvalue; track callExpDateMap) {
                  <mat-expansion-panel
                    data-options-panel
                    (opened)="openPanel(callExpDateMap.key)"
                    (closed)="closePanel(callExpDateMap.key)">
                    <mat-expansion-panel-header class="tbl-header">
                      <span class="mr-15px">{{ optionsChainTableData?.symbol }} </span>
                      <span class="mr-15px">{{ getDateValue(callExpDateMap.key) }} </span>
                      <span>{{ getDTE(callExpDateMap.key) }} days Remaining </span>
                    </mat-expansion-panel-header>
                    <ng-template matExpansionPanelContent>
                      <div class="d-flex">
                        @if ((optionsChainTableData?.callExpDateMap | json) != {}) {
                          <section class="table" id="callsTable">
                            <div class="tbl-data"
                              [ngClass]="{'scroll': showDetails && selectedChainType === 'Calls and Puts'}">
                              <table>
                                <tr>
                                  @if (selectedChainType === 'Calls') {
                                    <th
                                      class="sticky">
                                      <div class="strike-price sticky-div">Strike</div>
                                    </th>
                                  }
                                  <th class="text-left sticky">
                                    <div class="sticky-div">Calls</div>
                                  </th>
                                  <th class="prob-worth">Prob Worthless</th>
                                  <th>DTE</th>
                                  <th>Bid</th>
                                  <th>Ask</th>
                                  <th>Last</th>
                                  @if (showDetails) {
                                    <th>Change</th>
                                    <th>Vol</th>
                                    <th>Op Int</th>
                                    <th>Delta</th>
                                    <th>Gamma</th>
                                    <th>Theta</th>
                                    <th>Vega</th>
                                  }
                                </tr>
                                @for (call of callExpDateMap.value | keyvalue: returnZero; track call) {
                                  <tr
                                    [ngClass]="{'in-the-money':  call.value[0]?.inTheMoney}">
                                    @if (selectedChainType === 'Calls') {
                                      <td
                                        class="sticky">
                                        <div class="strike-price sticky-div">{{ getFloat(call.value[0].strikePrice) }}</div>
                                      </td>
                                    }
                                    <td class="text-left sticky">
                                      <div class="sticky-div" [ngClass]="{'in-the-money':  call.value[0]?.inTheMoney}">
                                        <a (click)="addToTray(optionsChainTableData?.symbol, call.value[0].symbol)">
                                          {{ getFloat(call.value[0]?.strikePrice) }} {{ call.value[0]?.putCall | titlecase}}
                                        </a>
                                      </div>
                                    </td>
                                    <td class="prob-worth">{{ getProbWorth(call.value[0]?.delta) }}%</td>
                                    <td>{{ getDTE(callExpDateMap.key)}}</td>
                                    <td>{{ getFloat(call.value[0]?.bid) }}</td>
                                    <td>{{ call.value[0]?.ask }}</td>
                                    <td>{{ getFloat(call.value[0]?.last) }}</td>
                                    @if (showDetails) {
                                      <td>{{ getFloat(call.value[0]?.netChange) }}</td>
                                      <td>{{ call.value[0]?.totalVolume }}</td>
                                      <td>{{ call.value[0]?.openInterest }}</td>
                                      <td>{{ getFloat(call.value[0]?.delta) }}</td>
                                      <td>{{ getFloat(call.value[0]?.gamma) }}</td>
                                      <td>{{ getFloat(call.value[0]?.theta) }}</td>
                                      <td>{{ getFloat(call.value[0]?.vega) }}</td>
                                    }
                                  </tr>
                                }
                              </table>
                            </div>
                          </section>
                        }
                        @if (selectedChainType !== 'Calls') {
                          <section class="table" id="putsTable">
                            <div class="tbl-data"
                              [ngClass]="{'scroll': showDetails && selectedChainType !== 'Calls' && selectedChainType !== 'Puts' }">
                              <table>
                                <tr>
                                  <th class="strike-price sticky">
                                    <div class="sticky-div">Strike</div>
                                  </th>
                                  <th class="text-left sticky sticky-2">
                                    <div class="sticky-div">Puts</div>
                                  </th>
                                  <th class="prob-worth">Prob Worthless</th>
                                  <th>DTE</th>
                                  <th>Bid</th>
                                  <th>Ask</th>
                                  <th>Last</th>
                                  @if (showDetails) {
                                    <th>Change</th>
                                    <th>Vol</th>
                                    <th>Op Int</th>
                                    <th>Delta</th>
                                    <th>Gamma</th>
                                    <th>Theta</th>
                                    <th>Vega</th>
                                  }
                                </tr>
                                @for (put of optionsChainTableData.putExpDateMap[callExpDateMap.key] | keyvalue: returnZero; track put) {
                                  <tr
                                    [ngClass]="{'in-the-money':  put.value[0]?.inTheMoney}">
                                    <td class="sticky">
                                      <div class="strike-price sticky-div">{{ getFloat(put.value[0].strikePrice) }}</div>
                                    </td>
                                    <td class="text-left sticky sticky-2">
                                      <div class="sticky-div" [ngClass]="{'in-the-money':  put.value[0]?.inTheMoney}">
                                        <a (click)="addToTray(optionsChainTableData?.symbol, put.value[0].symbol)">
                                          {{ getFloat(put.value[0]?.strikePrice) }} {{ put.value[0]?.putCall | titlecase }}
                                        </a>
                                      </div>
                                    </td>
                                    <td class="prob-worth">{{ getProbWorth(put.value[0]?.delta) }}%</td>
                                    <td>{{ getDTE(callExpDateMap.key)}}</td>
                                    <td>{{ getFloat(put.value[0]?.bid) }}</td>
                                    <td>{{ put.value[0]?.ask }}</td>
                                    <td>{{ getFloat(put.value[0]?.last) }}</td>
                                    @if (showDetails) {
                                      <td>{{ getFloat(put.value[0]?.netChange) }}</td>
                                      <td>{{ put.value[0]?.totalVolume }}</td>
                                      <td>{{ put.value[0]?.openInterest }}</td>
                                      <td>{{ getFloat(put.value[0]?.delta) }}</td>
                                      <td>{{ getFloat(put.value[0]?.gamma) }}</td>
                                      <td>{{ getFloat(put.value[0]?.theta) }}</td>
                                      <td>{{ getFloat(put.value[0]?.vega) }}</td>
                                    }
                                  </tr>
                                }
                              </table>
                            </div>
                          </section>
                        }
                      </div>
                    </ng-template>
                  </mat-expansion-panel>
                }
              </mat-accordion>
            }
            @if (selectedChainType === 'Puts') {
              <div class="puts-only-table">
                <mat-accordion multi [togglePosition]="'before'">
                  @for (putExpDateMap of optionsChainTableData?.putExpDateMap | keyvalue; track putExpDateMap) {
                    <mat-expansion-panel
                      data-options-panel
                      (opened)="openPanel(putExpDateMap.key)"
                      (closed)="closePanel(putExpDateMap.key)">
                      <mat-expansion-panel-header class="tbl-header">
                        <span class="mr-15px">{{ optionsChainTableData?.symbol }} </span>
                        <span class="mr-15px">{{ getDateValue(putExpDateMap.key) }} </span>
                        <span>{{ getDTE(putExpDateMap.key) }} days Remaining </span>
                      </mat-expansion-panel-header>
                      <ng-template matExpansionPanelContent>
                        <div class="d-flex">
                          @if ((optionsChainTableData?.putExpDateMap | json) != {}) {
                            <section class="table" id="putsOnlyTable">
                              <div>
                                <div class="tbl-data">
                                  <table>
                                    <tr>
                                      <th class="strike-price">Strike</th>
                                      <th class="text-left">Puts</th>
                                      <th class="prob-worth">Prob Worthless</th>
                                      <th>DTE</th>
                                      <th>Bid</th>
                                      <th>Ask</th>
                                      <th>Last</th>
                                      @if (showDetails) {
                                        <th>Change</th>
                                        <th>Vol</th>
                                        <th>Op Int</th>
                                        <th>Delta</th>
                                        <th>Gamma</th>
                                        <th>Theta</th>
                                        <th>Vega</th>
                                      }
                                    </tr>
                                    @for (put of optionsChainTableData.putExpDateMap[putExpDateMap.key] | keyvalue: returnZero; track put) {
                                      <tr
                                        [ngClass]="{'in-the-money':  put.value[0]?.inTheMoney}">
                                        <td class="strike-price">
                                          {{ getFloat(put.value[0].strikePrice) }}
                                        </td>
                                        <td class="text-left">
                                          <a (click)="addToTray(optionsChainTableData?.symbol, put.value[0].symbol)">
                                            {{ getFloat(put.value[0]?.strikePrice) }} {{ put.value[0]?.putCall | titlecase }}
                                          </a>
                                        </td>
                                        <td>{{ getProbWorth(put.value[0]?.delta) }}%</td>
                                        <td>{{ getDTE(putExpDateMap.key)}}</td>
                                        <td>{{ getFloat(put.value[0]?.bid) }}</td>
                                        <td>{{ put.value[0]?.ask }}</td>
                                        <td>{{ getFloat(put.value[0]?.last) }}</td>
                                        @if (showDetails) {
                                          <td>{{ getFloat(put.value[0]?.netChange) }}</td>
                                          <td>{{ put.value[0]?.totalVolume }}</td>
                                          <td>{{ put.value[0]?.openInterest }}</td>
                                          <td>{{ getFloat(put.value[0]?.delta) }}</td>
                                          <td>{{ getFloat(put.value[0]?.gamma) }}</td>
                                          <td>{{ getFloat(put.value[0]?.theta) }}</td>
                                          <td>{{ getFloat(put.value[0]?.vega) }}</td>
                                        }
                                      </tr>
                                    }
                                  </table>
                                </div>
                              </div>
                            </section>
                          }
                        </div>
                      </ng-template>
                    </mat-expansion-panel>
                  }
                </mat-accordion>
              </div>
            }
          </div>
        </div>
      }

      @if (!isDataAvailable && isNoResults) {
        <div class="no-results">
          No results found.
        </div>
      }
    </div>

    @if (isDataAvailable) {
      <div class="note-wrapper">
        <span class="in-the-money-icon"></span>
        <span class="footnote">Indicates options that are in the money</span>
      </div>
    }

    @if (!initialLoad && isTrayVisible) {
      <div>
        <irb-option-chains-tray
          [optionChainData]="map"
        (deleteOption)="deleteOption($event)"></irb-option-chains-tray>
      </div>
    }

    <div class="btn-wrapper">
      <button id="closeButton" (click)="close(true)" class="btn-medium-secondary">Cancel</button>
      <button id="selectButton" class="btn-medium-primary" [disabled]="isSelectButtonDisable" (click)="selectOptions()">
        Select
      </button>
    </div>
  </div>
